// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify({
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200,
      xl: 1400,
    },
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        colors: {
          primary: "#370B0B",
          secondary: "#E26D6D",
          tertiary: "#FBEAEA",
          light: "#FEF9F9",
          error: "#FED3D3",
          warning: "#FEF2D3",
        },
        dark: false,
      },
    },
    defaultTheme: "light",
  },
});
